export default __webpack_public_path__ + "static/media/FooterImg.88d9e5f3.png";